import { render } from "./RequiresAttentionCases.vue?vue&type=template&id=38a6c619"
import script from "./RequiresAttentionCases.vue?vue&type=script&lang=js"
export * from "./RequiresAttentionCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/RequiresAttentionCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38a6c619"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38a6c619', __exports__)) {
    console.log('reload')
    api.reload('38a6c619', __exports__)
  }
  
  module.hot.accept("./RequiresAttentionCases.vue?vue&type=template&id=38a6c619", () => {
    console.log('re-render')
    api.rerender('38a6c619', render)
  })

}


export default __exports__